import { forwardRef, ReactNode } from "react";
import { Box, BoxProps, styled } from "@mui/material";

export type SectionCardProps = BoxProps & {
    children: ReactNode;
};

const SectionCardSurface = styled(Box)(({ theme }) => {
    const stroke = theme.custom.strokes.containerDivider;

    return {
        backgroundColor: theme.custom.grey[100],
        borderColor: stroke.color,
        borderRadius: theme.spacing(1.5),
        boxShadow: theme.custom.shadows.grey,
        overflow: "hidden",
        position: "relative",
        width: "100%",
    };
});

/**
 * White card shell shared by the v2 product form and the informations detail tab.
 * Surface tokens follow Figma `12819:67408` ("Form content").
 */
export const SectionCard = forwardRef<HTMLDivElement, SectionCardProps>((props, ref) => {
    const { children, sx, ...rest } = props;
    return (
        <SectionCardSurface ref={ref} sx={sx} {...rest}>
            {children}
            <Box
                aria-hidden
                sx={(theme) => ({
                    borderColor: "inherit",
                    borderRadius: "inherit",
                    borderStyle: theme.custom.strokes.containerDivider.style,
                    borderWidth: theme.custom.strokes.containerDivider.width,
                    inset: 0,
                    pointerEvents: "none",
                    position: "absolute",
                })}
            />
        </SectionCardSurface>
    );
});

SectionCard.displayName = "SectionCard";
